<template>
    <div class="lni-c-box--content lni-u-mhauto lni-u-mv3">
        <lni-html-element
            :id="`${id}_intro`"
            class="lni-u-reading-width--max"
            :htmlString="content.jobReportIntro"
        />
        <lni-janitorial-calculations :id="`${id}_calculations`" />
        <lni-html-element
            :id="`${id}_disclaimer`"
            class="lni-u-mt3 lni-u-type--bold lni-u-type--xxs lni-u-line-height--tight"
            :htmlString="content.disclaimer"
        />
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'LniJobReportPage',
    data() {
        return {
            id: 'job-report',
        };
    },
    computed: {
        ...mapGetters({
            content: 'appState/content',
        }),
    },
}; </script>